import { render, staticRenderFns } from "./RotationalMenuCard.vue?vue&type=template&id=ae126202&scoped=true"
import script from "./RotationalMenuCard.vue?vue&type=script&lang=ts"
export * from "./RotationalMenuCard.vue?vue&type=script&lang=ts"
import style0 from "./RotationalMenuCard.vue?vue&type=style&index=0&id=ae126202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae126202",
  null
  
)

export default component.exports